import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "./Dialog";
import { Button } from "./Button";
import { Icon } from "./Icon";
import { plan2plateIcons } from "../../utils/iconUtils";

export function ConfirmModal(props: {
  open: boolean;
  title: string;
  description?: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
  icon?: keyof typeof plan2plateIcons;
  onConfirm: () => void;
  onCancel: () => void;
  dataCy?: string;
}) {
  return (
    <Dialog open={props.open} onOpenChange={(v) => !v && props.onCancel()}>
      <DialogContent data-cy={props.dataCy}>
        <DialogHeader>
          <div className="flex items-center gap-2">
            {props.icon && <Icon size={20}>{plan2plateIcons[props.icon]}</Icon>}
            <DialogTitle>{props.title}</DialogTitle>
          </div>
          {props.description != null && (
            <DialogDescription>{props.description}</DialogDescription>
          )}
        </DialogHeader>
        <div className="flex items-center justify-end gap-2 pt-1">
          <Button variant="tertiary" onClick={props.onCancel}>
            {props.cancelLabel ?? "Abbrechen"}
          </Button>
          <Button
            variant={props.destructive ? "destructive" : "primary"}
            onClick={props.onConfirm}
            dataCy={props.dataCy ? `${props.dataCy}-confirm` : undefined}
          >
            {props.confirmLabel ?? "Bestätigen"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
